import { v4 as uuidv4 } from 'uuid'

type Headers = { [x: string]: string }

export const getUpdatedHeaders = (
  headers: Headers,
  sessionId: string,
  userId?: number,
) => {
  const headersCopy: Headers = { ...headers }
  const value = `request_id=${sessionId}$$${uuidv4()}${
    userId ? `$$${userId}` : ''
  };requested_by=web`
  headersCopy['x-amzn-trace-id'] = value
  return headersCopy
}
